import React from "react";
import { Column, Row } from "@/shared/ui/Blocks";
import { Icon, IconColor, IconName } from "@/shared/ui/Icon";
import { cn } from "@/shared/utils/shadcn";

interface ResourceCardProps {
  icon?: string;
  title: string;
  tag: string;
  onClick: () => void;
  color?: string; // "green" | "blue" | "orange"
}

function ResourceCard({ icon, title, tag, onClick, color }: ResourceCardProps) {
  return (
    <Column
      className={cn(
        "h-[160px] w-[136px] rounded-l-lg pr-4 border-2 cursor-pointer",
        "hover:shadow-sm hover:shadow-gray-200 hover:scale-101 transition-all duration-300",
        color === "green" && "border-green-100",
        color === "blue" && "border-blue-100",
        color === "orange" && "border-orange-100"
      )}
      onClick={onClick}
    >
      <Column
        className={cn(
          "pl-4 py-2 rounded-l-lg justify-between h-full pr-2",
          color === "green" && "bg-green-100",
          color === "blue" && "bg-blue-100",
          color === "orange" && "bg-orange-100"
        )}
      >
        <Row className="items-center justify-between gap-2 ">
          <p
            className={cn(
              "text-2xs font-medium uppercase",
              color === "green" && "text-green-500",
              color === "blue" && "text-blue-500",
              color === "orange" && "text-orange-500"
            )}
          >
            {tag}
          </p>
          {!!icon && (
            <Icon
              icon={icon as IconName}
              color={color as IconColor}
              size="sm"
            />
          )}
        </Row>
        <p className="text-sm leading-tight font-light">{title}</p>
      </Column>
    </Column>
  );
}

export default ResourceCard;
